(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name entitats.controller:EntitatsCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats')
    .controller('EntitatsCtrl', EntitatsCtrl);

  function EntitatsCtrl() {
    var vm = this;
    vm.ctrlName = 'EntitatsCtrl';
  }
}());
